import { PropsWithChildren } from 'react';

/**
 * ContentActionBar component for wrapping the content of the action bar.
 */
function ContentActionBar({ children }: PropsWithChildren) {
  return (
    <div className="content-action-bar">
      <div className="max-container">{children}</div>
    </div>
  );
}

export default ContentActionBar;
